import React from 'react';
import LegalPageLayout, { H2, P, UL } from '../../components/LegalPageLayout';

export default function TermsOfUse() {
  return (
    <LegalPageLayout title="Terms of Use" lastUpdated="May 31, 2026" testId="terms-of-use-page">
      <P>
        These Terms of Use govern your access to and use of SecondDoctorOpinion.com (the "Service"). By
        creating an account or submitting a case, you agree to these terms in full.
      </P>

      <H2>1. Eligibility</H2>
      <UL>
        <li>You must be at least 18 years of age to register and submit cases.</li>
        <li>For minors, a parent or legal guardian must submit on their behalf.</li>
        <li>Doctors registering on the platform must hold a valid, currently-active MCI/SMC/NMC registration.</li>
      </UL>

      <H2>2. Nature of the Service</H2>
      <P>
        SecondDoctorOpinion.com is a technology platform that connects patients seeking a second medical
        opinion with independently licensed specialists. We are <strong>not</strong> a medical practice,
        hospital, or licensed healthcare provider. The medical opinion is the professional judgment of the
        individual specialist who reviewed your case.
      </P>
      <P>
        Please read our <strong>Medical Disclaimer</strong> carefully — it is incorporated into these Terms
        by reference.
      </P>

      <H2>3. User Responsibilities</H2>
      <UL>
        <li>Provide accurate, complete, and truthful information about your medical condition and history.</li>
        <li>Upload only legitimate medical records belonging to the person whose case is being submitted.</li>
        <li>Maintain the confidentiality of your account credentials. You are responsible for all activity under your account.</li>
        <li>Notify us immediately at <strong>support@seconddoctoropinion.com</strong> of any unauthorized account access.</li>
        <li>Do not impersonate any individual or misrepresent your identity or credentials.</li>
      </UL>

      <H2>4. Payment Terms</H2>
      <UL>
        <li>Basic Consultation: ₹1,500 — written specialist opinion within 48 hours.</li>
        <li>Premium Detailed Consultation: ₹2,500 — multi-specialist review with video consultation.</li>
        <li>Payment must be completed via Stripe (card/netbanking) or UPI (Google Pay / PhonePe / Paytm) before your case is assigned to a specialist.</li>
        <li>All fees are inclusive of applicable taxes unless stated otherwise.</li>
      </UL>

      <H2>5. Acceptable Use</H2>
      <P>You agree NOT to:</P>
      <UL>
        <li>Use the Service for medical emergencies (call 112 immediately)</li>
        <li>Submit false, misleading, or fraudulent information</li>
        <li>Upload malware, viruses, or harmful content</li>
        <li>Attempt to reverse-engineer, decompile, or gain unauthorized access to our systems</li>
        <li>Use the Service to harass, defame, or harm any specialist, staff member, or other user</li>
        <li>Resell, redistribute, or commercially exploit the opinions or content from the platform</li>
      </UL>

      <H2>6. Intellectual Property</H2>
      <P>
        All content on SecondDoctorOpinion.com — including the platform's design, code, logo, written
        content, and AI-assisted analysis templates — is the property of SecondDoctorOpinion.com or its
        licensors. Medical opinions issued through the platform are intended solely for the patient's
        personal use and may not be republished without written permission.
      </P>

      <H2>7. Doctor Panel Terms</H2>
      <UL>
        <li>Doctors apply for approval; admission to the panel is at our sole discretion based on verification of credentials.</li>
        <li>Doctors agree to provide opinions in good faith, exercising the same standard of care expected of an Indian medical specialist in their field.</li>
        <li>Doctors retain full personal professional and legal responsibility for the opinions they issue.</li>
        <li>Referral payouts (₹500 per referred paid consultation) are settled monthly via bank transfer or UPI.</li>
      </UL>

      <H2>8. Limitation of Liability</H2>
      <P>
        To the maximum extent permitted by Indian law, SecondDoctorOpinion.com, its affiliates, employees,
        and directors shall not be liable for any indirect, incidental, special, consequential, or punitive
        damages arising out of or related to your use of the Service. Our total cumulative liability for any
        claim shall not exceed the amount you paid for the specific consultation giving rise to the claim.
      </P>

      <H2>9. Indemnification</H2>
      <P>
        You agree to indemnify and hold harmless SecondDoctorOpinion.com from any claims, losses, or
        damages arising out of (a) your breach of these Terms, (b) your misuse of the Service, or (c) any
        false or misleading information you provide.
      </P>

      <H2>10. Termination</H2>
      <P>
        We may suspend or terminate your account at any time for violation of these Terms, fraudulent
        activity, or where required by law. You may delete your account at any time by contacting support.
      </P>

      <H2>11. Governing Law & Jurisdiction</H2>
      <P>
        These Terms are governed by the laws of India. Any disputes shall be subject to the exclusive
        jurisdiction of the courts at <strong>Lucknow, Uttar Pradesh, India</strong>.
      </P>

      <H2>12. Changes to These Terms</H2>
      <P>
        We may modify these Terms at any time. Material changes will be communicated via email and a notice
        on this page at least 7 days before they take effect. Continued use of the Service after changes
        constitutes acceptance.
      </P>
    </LegalPageLayout>
  );
}
